import React from "react";
import { Container } from "./styles";

const CallScreen = () => {
  return <Container />;
};

export default CallScreen;
